<template>
    <div class="card" style="width: 22rem;">
        <div class="card-body">
            <h5 class="card-title">Cover limits</h5>
            <hr />
            <div v-if="policyDetails">
                <div class="row">
                    <div class="col">
                        <p class="card-text font-weight-bold">Rate type</p>
                    </div>
                    <div class="col">
                        <p class="card-text font-weight-light">{{rateTypeDisplayName(policyDetails.policyRatingTypeId)}}</p>
                    </div>
                </div>
                <div v-if="policyDetails.policyRatingTypeId == 2">
                    <div class="row">
                        <div class="col">
                            <p class="card-text font-weight-bold">Single article limit</p>
                        </div>
                        <div class="col">
                            <p class="card-text font-weight-light">&pound;{{formatNumber2(policyDetails.sal)}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <p class="card-text font-weight-bold">Aggregate limit</p>
                        </div>
                        <div class="col">
                            <p class="card-text font-weight-light">&pound;{{formatNumberWithCommas(policyDetails.coverLimit)}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div  v-else class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { formatNumber } from '@/util/formatters'

    export default {
        name: 'PolicyCoverLimits',
        components: {
            
        },
        mixins: [
            
        ],
        data: () => {
            return {

            }
        },
        computed: {
            selectedClaim() {
                return this.$store.getters.selectedClaim
            },
            policyDetails() {
                return this.selectedClaim.policyDetails
            }
        },
        mounted() {
            
        },
        methods: {
            formatNumber2(val) {
                return formatNumber(2)(val)
            },
            formatNumberWithCommas(val) {
                return this.formatNumber2(val).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
            },
            rateTypeDisplayName(typeId) {
                switch (typeId) {
                    case 1:
                        return 'Individual item'
                        break
                    case 2:
                        if (this.policyDetails.deserialisedObject.gadgets) {
                            return `Bundle (${this.policyDetails.deserialisedObject.gadgets.length} gadgets)`
                        } else {
                            return `Bundle`
                        }
                        
                        break
                    default:
                        return 'Unknown'
                }
            }
        }
    }
</script>